import React from "react"
import { Link } from "react-router"
import FontAwesome from "react-fontawesome"
import AlertModal from "../fragments/AlertModal"
import ProcessesStatus from "../fragments/ProcessesStatus"
import { batchDataWithId, validateTextState, VALIDATION_TYPE } from "../../lib/utils"
import apiServerApi from "../../redux/sagas/apiServerApi"
import { blockingFetchService } from "../../lib/blockingFetch"
import { connect } from "react-redux"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../redux/items/types"
import FormControlInlineSelect from "../fragments/FormControl.Inline.Select"
import { Col, Row } from "react-bootstrap"

class RenderFinancierBatch extends React.Component {

  state = {
    shouldUpdateBatch: false,
    shouldUnlinkBatch: false,
    running: false,
    success: false,
    error: null,
    batchId: '',
    batchIdValidationState: VALIDATION_TYPE.NULL
  }

  componentDidMount() {
    this.props.loadData()
  }

  handleUpdate = () => this.setState({ 
    shouldUpdateBatch: true,
    batchId: this.props.batch ? this.props.batch.id : '',
    batchIdValidationState: VALIDATION_TYPE.NULL,
    running: false,
    success: false,
    error: null
  })

  handleUnlink = () => this.setState({ 
    shouldUnlinkBatch: true,
    running: false,
    success: false,
    error: null
  })

  batchIdChanged = batchId => this.setState({
    batchId,
    batchIdValidationState: validateTextState(batchId, false),
    error: null,
  })

  confirmUpdate = () => {

    const { batchId } = this.state,
    batchIdState = validateTextState(batchId, false)

    if (batchIdState !== VALIDATION_TYPE.SUCCESS) {
      this.setState({
        error: 'Invalid batch.',
        batchIdValidationState: batchIdState
      })
      return
    }

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { loanId, reloadLoan } = this.props

    blockingFetchService(
      accessToken => apiServerApi.addLoanFinancierBatch(accessToken, batchId, loanId),
      _ => {
        this.setState({ success: true })
        setTimeout(this.closeUpdate, 1000)
        reloadLoan(loanId)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  confirmUnlink = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { batch: { id: batchId }, loanId, reloadLoan } = this.props

    blockingFetchService(
      accessToken => apiServerApi.removeLoanFinancierBatch(accessToken, batchId, loanId),
      _ => {
        this.setState({ success: true })
        setTimeout(this.closeUnlink, 1000)
        reloadLoan(loanId)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  closeUpdate = () => this.setState({ shouldUpdateBatch: false })

  closeUnlink = () => this.setState({ shouldUnlinkBatch: false })

  updateContent = () => {

    const { running, success, error, batchId, batchIdValidationState } = this.state,
    { batches } = this.props

    return (
      <div>
        <Row>
          <Col xs={12}>

            <FormControlInlineSelect
              controlId='batchId' validationState={ batchIdValidationState }
              label='Batch' value={ batchId }
              onChange={ this.batchIdChanged }
              options={ batches }
              withEmptyOption={ true }
              helpText={ batchIdValidationState === VALIDATION_TYPE.ERROR ? 'Choose a batch' : '' }
            />
          </Col>
        </Row>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  unlinkContent = () => {
    const { running, success, error } = this.state
    return (
      <div>
        <h3>Do you really want to unlink this batch?</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  renderUpdateLink = className => (
    <span className={ `cursor-pointer ${ className } p-5` }
      onClick={ this.handleUpdate } title='Update'>
      <FontAwesome name="pencil" />
    </span>
  )

  renderUnlink = () => (
    <span className="red cursor-pointer ml-10 p-5" title="Unlink this batch!"
      onClick={ this.handleUnlink }>
      <FontAwesome name='trash' />
    </span>
  )

  renderContent = () => {

    const { batch } = this.props
    if (!batch) return this.renderUpdateLink('')

    const { id, name, affiliation } = batch
    return <div>
      <Link to={`/financiers/batches/${id}/detail`} title='Show details'>
        { name } { affiliation ? `(${ affiliation.name })` : '' }
      </Link>
      { this.renderUpdateLink('ml-10') }
      { this.renderUnlink() }
    </div>
  }

  render() {  
    const { shouldUpdateBatch, running, shouldUnlinkBatch } = this.state

    return <div>

      { this.renderContent() }

      <AlertModal
        show={ shouldUpdateBatch }
        title='Update batch'
        body={ this.updateContent() }
        bsStyle="info"
        close={ this.closeUpdate }
        confirm={ this.confirmUpdate }
        proceedText="Proceed"
        disabled={ running }
      />

      <AlertModal
        show={ shouldUnlinkBatch }
        title='Unlink batch'
        body={ this.unlinkContent() }
        bsStyle="danger"
        close={ this.closeUnlink }
        confirm={ this.confirmUnlink }
        proceedText="Proceed"
        disabled={ running }
      />
    </div>
  }
}

const mapStateToProps = (state, { affiliationId }) => {

  let batches = DckSelectors.selectAllItems(state, ItemTypes.FinancierBatch)
  batches = batches.filter(({ closed, affiliation: aff }) => !closed && aff && aff.id === affiliationId)
  batches.sort((a, b) => a.name.localeCompare(b.name))
  batches = batchDataWithId(batches)

  return { batches }
},

mapDispatchToProps = dispatch => ({
  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.FinancierBatch)),
})

export default connect(mapStateToProps, mapDispatchToProps)(RenderFinancierBatch)



// WEBPACK FOOTER //
// ./src/components/Loans/RenderFinancierBatch.js